import { url } from '@api-config';
import { initAuthToken, logout } from 'utils/Auth';
import { app_json_content_type, getAuthToken } from 'Api/utils/getAuthHeaders';

let isRefreshing = false;
let refreshTokenPromise: Promise<void> | null = null;

/**
 * Requests a refresh token for local authentication flow
 */
export const requestRefreshTokenLocalAuth = async () => {
  if (isRefreshing) {
    return refreshTokenPromise;
  }

  isRefreshing = true;
  refreshTokenPromise = (async () => {
    try {
      // fetch new token
      const newTokensResponse = await fetch(url.refreshTokenLocalAuth, {
        method: 'POST',
        headers: {
          'Content-Type': app_json_content_type,
        },
        body: JSON.stringify({
          refreshToken: getAuthToken(),
        }),
      });

      initAuthToken(newTokensResponse, true, '');
    } catch (err) {
      console.warn('There was an error getting the refresh tokens:', err);
      logout();
    } finally {
      isRefreshing = false;
      refreshTokenPromise = null;
    }
  })();

  return refreshTokenPromise;
};
